import React from "react";
import classes from "./PageSummary.module.css";

const FeedbackSummary = () => {
  return (
    <section className={classes.summary}>
      <h2 style={{ fontWeight: "bold" }}>
        Welcome to the @one Alliance Engineering Feedback Page
      </h2>
      <p>
        Here you can submit any feedback you have. You can also refer to
        frequently asked questions (FAQs) to see if there is already an answer
        to a query you have.
      </p>
      {/* <p></p> */}
      {/* <p>
        This area is currently under development and more releases are planned
        over the coming weeks and months. Please check back regularly for new
        updates and look out for communications coming your way.
      </p> */}
      <p>
        For all questions, or to tell us what you think, please contact
        oneengineering@anglianwater.co.uk
      </p>
    </section>
  );
};

export default FeedbackSummary;
